"use strict";

exports.__esModule = true;
exports.CATEGORY_TYPE_PRIVATE = exports.CATEGORY_TYPE_MEMBERS_ONLY = exports.CATEGORY_TYPE_PUBLIC = void 0;
var CATEGORY_TYPE_PUBLIC = 'public';
exports.CATEGORY_TYPE_PUBLIC = CATEGORY_TYPE_PUBLIC;
var CATEGORY_TYPE_MEMBERS_ONLY = 'membersOnly';
exports.CATEGORY_TYPE_MEMBERS_ONLY = CATEGORY_TYPE_MEMBERS_ONLY;
var CATEGORY_TYPE_PRIVATE = 'private';
exports.CATEGORY_TYPE_PRIVATE = CATEGORY_TYPE_PRIVATE;